module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag02_0054AT.365ebb12.jpg";